import React, {useState, useEffect} from "react";
import usePagination from "../../../../../../hooks/usePagination";

// import i18n from "i18n";
import Pagination from "../../../../atoms/Pagination"
import ProductSummaryItem from "../ProductSummaryItem"
import Icon from "../../../../atoms/Icon/icon"
import {isMobile} from "../../../../../../helpers/Mobile";
import styles from "./ProductSummary.module.scss";
import i18n from "i18n";


export const ProductSummary = ({products, edit, handleEdit, paginationSize = 3}) => {
    const [ toggleOpen, setToggleOpen ] = useState(false)
    const [totalUnits, settotalUnits] = useState(0);
    const [list, currentPage, pageSize, pageList, pageQuantity, changePageSize, changePage, changeList] = usePagination(products, 0, paginationSize);

    useEffect(() => {
        settotalUnits([...products].reduce(function(a, prod) {
          return a + Number(prod.quantity || 0) + Number(prod.units || 0);
        }, 0));
        changeList(products, 0, paginationSize);
    }, [products]);
    return(
        <div className={styles["product-summary-wrapper"]}>
            <div className={styles["product-summary-title"] + (edit ? ' ' + styles["edit"] : "")} onClick={() => setToggleOpen(!toggleOpen)}>
                <div className={styles["product-summary-title-wrapper"] + (edit ? ' ' + styles["edit"] : "") }>
                    {i18n.t("requested.products")} ({products.length})
                </div>
                {edit && <div className={styles["product-summary-edit-icon"]} onClick={handleEdit}>
                    <Icon name="edit2" width={20} height={20} fill={"#3C7AF5"}/>
                </div>}
                {(isMobile && !edit) &&
                    <i className={"icon-chevron " + styles["product-summary-chevron"] + (toggleOpen ? " " + styles["open"] : "") }></i>
                }
            </div>
            <div className={`${styles['product-summary-total-units']} ${edit ? styles.edit : ''}`}>
                {i18n.t("units").toUpperCase()} ({totalUnits})
            </div>
            {(!isMobile || toggleOpen) && <div className={styles["product-summary-products"]}>
                {pageList.map(product => {
                    return <ProductSummaryItem product={product} stock={product.stock} units={product.units} key={product?.code ?? product?.id}/>
                })}
            </div>}
            {!isMobile && <div className={styles["product-summary-pagination"]}> <Pagination pageQuantity={pageQuantity} currentPage={currentPage} pageChangeHandler={changePage} /> </div>}
        </div>
    )
}

export default ProductSummary;